module.exports = __webpack_public_path__ + "static/media/Rendering.523d1be8.jpg";